import { FC, useState, useContext } from "react";
import { useMutation } from "react-query";
import client from "src/api";
import Button from "src/components/ui/button";
import { Input, Form } from "antd";
import { useModalAction } from "./context";
import GlobalContext from "src/context/global-context";
import { getErrorMessage } from "src/lib/utils";
import { NetworkDisconnectMsg, APISomethingWrongMsg } from "src/lib/constants";

const AddPermissionView: FC = () => {
  const [permissionName, setPermissionName] = useState("");
  const { closeModal } = useModalAction();
  const { setAlertText, setIsAlertOpened } = useContext(GlobalContext);

  const { mutate: addPermission, isLoading } = useMutation(
    client.admins.addPermissions,
    {
      onSuccess: () => {
        setAlertText("Permission added successfully!");
        setIsAlertOpened(true);
        closeModal();
      },
      onError: (error: any) => {
        if (error.code === "ERR_NETWORK") {
          setAlertText(NetworkDisconnectMsg);
        } else if (error.response) {
          setAlertText(getErrorMessage(error.response.data));
        } else {
          setAlertText(APISomethingWrongMsg);
        }
        setIsAlertOpened(true);
        closeModal();
      },
    }
  );

  const onSubmit = () => {
    if (!permissionName.trim()) return;
    addPermission({ name: permissionName });
  };

  return (
    <div
      className="bg-white shadow-xl rounded-xl p-6 w-[340px] sm:w-[420px] 
                 flex flex-col gap-6 text-primary font-manrope"
    >
      {/* Title */}
      <p className="text-[22px] font-semibold text-primary">Add Permission</p>

      {/* Input */}
      <Form layout="vertical" className="!mb-0">
        <Form.Item
          label={
            <span className="text-secondary font-medium">Permission Name</span>
          }
          required
          className="!mb-4"
        >
          <Input
            placeholder="Enter permission name"
            value={permissionName}
            onChange={(e) => setPermissionName(e.target.value)}
            className="rounded-md h-[40px] border border-gray-300 focus:border-primary focus:shadow-md"
          />
        </Form.Item>
      </Form>

      {/* Actions */}
      <div className="flex justify-end gap-3 pt-2">
        <Button
          variant="outline"
          onClick={closeModal}
          className="!border-gray-400 text-secondary hover:bg-gray-100 px-4"
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          isLoading={isLoading}
          disabled={!permissionName.trim()}
          className="bg-primary text-white hover:bg-primary/90 px-4"
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default AddPermissionView;
